module.exports = __webpack_public_path__ + "static/media/about.4e55b42a.jpg";